import { useEffect } from "react";

const BASE_URL = "https://novalean-consulting.fr";
const DEFAULT_TITLE = "Nova Lean Consulting | Lean Management & Excellence Opérationnelle";
const DEFAULT_DESC = "Nova Lean Consulting — conseil industriel en Lean Management, Industrie 4.0, excellence opérationnelle et formation professionnelle.";

function setMeta(attr, key, content) {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    el.setAttribute("data-seo", "1");
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

export default function SEO({ title, description, path = "/", image = "", jsonLd = [] }) {
  const ldKey = JSON.stringify(jsonLd);
  useEffect(() => {
    const url = `${BASE_URL}${path}`;
    const img = image ? (image.startsWith("http") ? image : `${BASE_URL}${image}`) : `${BASE_URL}/images/majdi-zarougui.jpg`;
    document.title = title;
    setMeta("name", "description", description);
    setMeta("property", "og:type", "website");
    setMeta("property", "og:site_name", "NovaLean Consulting");
    setMeta("property", "og:title", title);
    setMeta("property", "og:description", description);
    setMeta("property", "og:url", url);
    setMeta("property", "og:image", img);
    setMeta("name", "twitter:card", "summary_large_image");
    setMeta("name", "twitter:title", title);
    setMeta("name", "twitter:description", description);
    setMeta("name", "twitter:image", img);
    let link = document.head.querySelector('link[rel="canonical"]');
    if (!link) {
      link = document.createElement("link");
      link.setAttribute("rel", "canonical");
      link.setAttribute("data-seo", "1");
      document.head.appendChild(link);
    }
    link.setAttribute("href", url);
    jsonLd.forEach((obj) => {
      const s = document.createElement("script");
      s.type = "application/ld+json";
      s.setAttribute("data-seo", "1");
      s.textContent = JSON.stringify(obj);
      document.head.appendChild(s);
    });
    return () => {
      document.title = DEFAULT_TITLE;
      setMeta("name", "description", DEFAULT_DESC);
      document.head.querySelectorAll("[data-seo]").forEach((el) => el.remove());
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [title, description, path, image, ldKey]);
  return null;
}
